import SiteWide from './modules/site-wide'
import svg4everybody from 'svg4everybody'

$(function () {
  try {
    // Modules initialised here…
    // Catch any errors...
    SiteWide().init()
    svg4everybody()
    require('./modules/search')
  } catch (error) {
    console.error(error)
  }
})
